import React from 'react';
import { FeedbackQuestion } from '../../../types/feedback';

interface TextQuestionProps {
  question: FeedbackQuestion;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const TextQuestion: React.FC<TextQuestionProps> = ({
  question,
  value,
  onChange,
  error
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="question-container">
      <label className="question-label">
        {question.question}
        {/* Removed required asterisk - all fields are now optional */}
      </label>
      
      <input
        type={question.type === 'email' ? 'email' : question.type === 'number' ? 'number' : 'text'}
        value={value}
        onChange={handleChange}
        placeholder={question.placeholder}
        className={`question-input ${error ? 'error' : ''}`}
        min={question.validation?.min}
        max={question.validation?.max}
        minLength={question.validation?.minLength}
        maxLength={question.validation?.maxLength}
        pattern={question.validation?.pattern}
      />
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default TextQuestion;
